<div [ngClass]="getClass()" id="shared-title-subtitle-parent">
  <div class="title-content" *ngIf="title" id="shared-title-contents-wrapper">
    <app-text [textStyleType]="titleFontStyle"
      >{{ title }}
      <span *ngIf="showTitleRequiredStar" class="title-content-required"
        >*</span
      ></app-text
    >
    <app-icon
      id="shared-title-icon-right-id"
      class="title-icon-right"
      [iconClassNames]="rightTitleIconClassNames"
      [name]="rightTitleIconName"
      [size]="rightTitleIconSize"
      *ngIf="showTitleRightIcon"
    >
    </app-icon>
    <app-icon
      *ngFor="let icon of otherTitleIcons"
      class="title-icon-right"
      [name]="icon.name"
      [iconClassNames]="icon.classNames || rightTitleIconClassNames"
      [color]="icon.color || ''"
      [size]="icon.size || rightTitleIconSize"
    >
    </app-icon>
  </div>

  <app-tooltip
    id="shared-title-subtitle-tooltip"
    [tootltipText]="subtitleToolTipText"
    [tooltipDelay]="'10'"
    [tooltipPosition]="'above'"
    [disabled]="!subtitleToolTipText"
    [tooltipCustomClass]="tooltipCustomClass"
  >
    <div id="shared-title-subtitle-tooltip-content" class="tooltip-content">
      <div
        id="shared-subtitle-content-wrapper"
        [class]="titleSubtitleClassName"
        [ngStyle]="subtitleStyles"
        *ngIf="subtitle"
      >
        <app-text
          [textStyleType]="subtitleFontStyle"
          [style]="subTitleStyle"
          [class]="tooltipCustomClass"
          id="shared-subtitle-text"
        >
          {{ subtitle }}
        </app-text>
        <app-icon
          id="shared-title-icon-right-id"
          class="title-icon-right"
          [name]="rightSubtitleIconName"
          [size]="rightSubtitleIconSize"
          [color]="rightSubtitleIconColor"
          *ngIf="showSubtitleRightIcon"
        >
        </app-icon>
        <app-text
          [textStyleType]="secondarySubtitleFontStyle"
          id="shared-secondary-subtitle-text"
          *ngIf="secondarySubtitle"
        >
          {{ secondarySubtitle }}
        </app-text>
      </div>
    </div>
  </app-tooltip>
</div>
